import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import TagManager from 'react-gtm-module'; // ✅ Import GTM

const tagManagerArgs = {
  gtmId: 'GTM-5FSPK9QL', // 🔁 Replace with your GTM ID
};

TagManager.initialize(tagManagerArgs); // ✅ Initialize GTM

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
